<template>
  <div class="wrapper" v-if="auth_user">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <div class="mt-3">
          <h5 class="text-uppercase text-center p-2 mb-4"  
            :style="{
              'background': PACKAGE_COLOR[auth_user.subscription.privileges.scpk_name.toLowerCase()] ? 
                PACKAGE_COLOR[auth_user.subscription.privileges.scpk_name.toLowerCase()].background : '#fff',
              'color': PACKAGE_COLOR[auth_user.subscription.privileges.scpk_name.toLowerCase()] ?
                PACKAGE_COLOR[auth_user.subscription.privileges.scpk_name.toLowerCase()].color : '#000',
            }"
          >
          <span v-if="!$sidebar.isMinimized || $sidebar.hovered">
            <b-icon icon="shield-fill-check" v-if="auth_user.subscription.scrb_is_my_own"  v-b-tooltip.hover="'Owner'"></b-icon>
            {{ auth_user.subscription.privileges.scpk_name }}
          </span></h5>
        </div>
        <sidebar-item :link="{ name: 'Dashboard', icon: 'ni ni-chart-pie-35' }">
          <sidebar-item :link="{ name: 'Leads', path: '/reports/lead' }" v-if="checkAccess(['l_report__listing'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Marketing Lead Analysis', path: '/reports/lead-analysis' }" v-if="_gHlp.checkAccess(['r__marketing_lead_analysis__listing'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Customers', path: '/reports/customer' }" v-if="checkAccess(['c_report__listing'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Customer Income Analysis', path: '/reports/customer-income-analysis' }" v-if="checkAccess(['r__customer_income_analysis'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Cases', path: '/reports/case' }" 
            v-if="checkAccess(['c_report__listing'])"></sidebar-item>
          <sidebar-item :link="{ name: 'KPI', path: '/reports/kpi' }" 
            v-if="checkAccess(['kpi_report__listing'])"></sidebar-item>
        </sidebar-item>

        <sidebar-item :link="{ name: 'Profile', icon: 'ni ni-circle-08' }">
          <sidebar-item :link="{ name: 'Leads', path: '/leadsListings' }" v-if="checkAccess(['l_lead__listing'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Customer Profile', path: '/customerProfile' }" v-if="checkAccess(['c_customer__listing'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Cases', path: '/casesListings', icon: 'ni ni-single-copy-04' }" v-if="checkAccess(['p_product__listing'])"/>
          <sidebar-item :link="{ name: 'Loan Advisory', path: '/loanAdvisoryListing', icon: 'ni ni-single-copy-04' }"  v-if="checkAccess(['loan_advisory_listing'])"/>
          <!-- <sidebar-item :link="{ name: 'Meeting', path: '/meetingsListings' }" v-if="checkAccess(['l_lead__create']) || checkRoleAccess('l_lead','access_create')"></sidebar-item> -->
          <!-- <sidebar-item :link="{ name: 'Calls', path: '/callsListings' }"></sidebar-item> -->
          <sidebar-item :link="{ name: 'Initial Proposal', path: '/initialProposal', icon: 'ni ni-single-copy-04', is_comming:true }" v-if=" _gHlp.checkAccess(['pr_proposal__listing'])"/>
        </sidebar-item>

        <sidebar-item :link="{ name: 'Sales', icon: 'ni ni-chart-bar-32', is_comming:true }" v-if="checkAccess(['proforma_invoice','bl_invoice__listing'])">
          <sidebar-item :link="{ name: 'ProForma Invoices Listing', path: '/proFormaInvoices' }" v-if="checkAccess(['proforma_invoice'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Invoices Listing', path: '/invoices' }" v-if="checkAccess(['bl_invoice__listing'])"></sidebar-item>
        </sidebar-item>

				<!-- <span class="nav-item" v-if=" !['SSE', 'Sales Executive', 'User', 'External User'].includes(this.auth_user.account_info.role_name)">
					<a href="javascript:void(0)" @click="goToCommission()" class="nav-link">
						<i class="fa fa-money-check"></i>
						<span class="nav-link-text d-flex justify-content-between w-100">
							<span>Commission</span>
						</span>
					</a>
				</span>
				
        <sidebar-item :link="{ name: 'Commission', icon: 'ni ni-money-coins' }" v-if="_gHlp.checkRoleType(['admin'])">
          <span class="nav-item">
            <a href="javascript:void(0)" @click="goToCommission()" class="nav-link">
              <span class="nav-link-text d-flex justify-content-between w-100">
                <span>Go to Commission</span>
              </span>
            </a>
          </span>
          <sidebar-item :link="{ name: 'Hub User', path: '/hubListings' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Hub', path: '/hubProfile' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Hub Approval', path: '/hubApproval' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Payout', path: '/payoutDistribution' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Recruitment', path: '/recruitmentListings' }"></sidebar-item>
        </sidebar-item> -->

        <sidebar-item :link="{ name: 'Reports', icon: 'ni ni-chart-bar-32' }" v-if="_gHlp.checkRoleType(['admin', 'manager'])">
          <!-- <sidebar-item :link="{ name: 'Monthly Commission Report', path: '/reports/monthlyCommission' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Company Revenue Summary', path: '/reports/companyRevenue' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Revenue Point Summary', path: '/reports/revenuePoint' }"></sidebar-item> -->
          <sidebar-item v-if="checkAccess(['revenue_report'])" :link="{ name: 'Revenue Report', path: '/reports/revenue' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Commission Report', path: '/reports/commission' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Sales Report', path: '/reports/sales' }"></sidebar-item>
        </sidebar-item>
        
				<sidebar-item :link="{ name: 'Credit Reports', icon: 'fa fa-poll' }">
          <sidebar-item :link="{ name: 'Purchased Reports', path: '/purchased-reports'}"></sidebar-item>
          <sidebar-item :link="{ name: 'Credit Balance', path: '/credit-balance' }"></sidebar-item>
          <!-- <sidebar-item :link="{ name: 'SME Reports', path: '/sme-reports' }"></sidebar-item> -->
        </sidebar-item>
        

        <sidebar-item :link="{ name: 'Calculator', path: '/calculators', icon: 'fa fa-calculator' }" 
          v-if="auth_user.subscription.privileges.scpk_name.toLowerCase() === 'corporate' || _gHlp.checkAccess(['cl_calculator__listing'])" 
        ></sidebar-item>

        <sidebar-item 
            :link="{ name: 'Pending Approvals', path: '/pendingApprovals', icon: 'ni ni-notification-70', alert: approval_count }" 
            v-if=" _gHlp.checkAccess(['a_approval__listing'])"
          />

        <sidebar-item 
            :link="{ name: 'Property Listing', path: '/propertyListing', icon: 'ni ni-building', is_comming:false }"
            v-if=" _gHlp.checkAccess(['property_listing_menu'])"
          />

        <!-- SETTING SHOULD ALWAYS BE LAST-->
        <sidebar-item :link="{ name: 'Settings', icon: 'ni ni-settings' }" class="pb-4">
          <sidebar-item :link="{ name: 'User Management', path: '/userManagement' }" v-if="_gHlp.checkAccess(['stg_user_management'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Hub User', path: '/hubListings' }" v-if="_gHlp.checkAccess(['stg_user_management'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Role Access', path: '/settings/roleAccess' }" v-if="_gHlp.checkAccess(['stg_role_access'])"></sidebar-item>
         	<sidebar-item :link="{ name: 'Status', path: '/settings/leadStatus' }" v-if="_gHlp.checkAccess(['stg_lead_status','stg_customer_status','stg_customer_status','stg_mortgage_status','stg_personal_loan_status','stg_insurance_status','stg_other_loan_status','stg_mhlv_status','stg_advisory_status'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Templates', path: '/settings/sms-templates' }" v-if="_gHlp.checkAccess(['stg_sms_template','stg_email_template'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Channel & Platform', path: '/settings/channelSetting' }" v-if="_gHlp.checkAccess(['stg_channel_platform'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Preferred Banks', path: '/settings/preferredBanks' }" v-if="_gHlp.checkAccess(['stg_preferred_banks'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Fees & Charges', path: '/settings/fees-charges' }" v-if="_gHlp.checkAccess(['stg_fees_and_charge'])"></sidebar-item>
					<sidebar-item :link="{ name: 'Invoice Setting', path: '/settings/invoice-categories' }" v-if="_gHlp.checkAccess(['stg_invoice_category'])"></sidebar-item>
          <sidebar-item :link="{ name: 'FWD Target', path: '/settings/fwd-target' }" v-if="_gHlp.checkAccess(['stg_fwd_target'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Customer Assignment', path: '/settings/customerAssignment' }" v-if="_gHlp.checkAccess(['stg_channel_platform'])"></sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>

        </fade-transition>
				<!-- Drawer for Messaging -->
				<MessagingDrawer ref="messaging_drawer_store"/>
				<SmsDrawer ref="sms_drawer_store"/>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';
  import { mapActions, mapState } from 'pinia'
  import { useApprovalStore } from '@/stores/approvalStore'
  import { useFintscoreStore } from '@/stores/fintscoreStore'
  import { useAuthStore } from '@/stores/authStore'
  import { useDashboardStore } from '@/stores/dashboardStore'
  import { helperFunctionMixin } from '@/assets/js/httpImports.js'
  import { MANAGER_ROLE_IDS } from '@/assets/js/roles.js' 
  import {PACKAGE_COLOR} from '@/assets/js/colors.js'
	import MessagingDrawer from '@/views/Messaging/MessagingDrawer'
	import SmsDrawer from '@/views/Sms/SmsDrawer'
	import chatEventBus from '@/assets/js/EventBus/chatEventBus.js'

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';
  import {getUserInfo, commissionDomain} from '@/assets/js/config.js'
  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition,
			MessagingDrawer,
      SmsDrawer
    },
    mixins: [helperFunctionMixin],
    data() {
      return {
        loginUser : getUserInfo(),
        demo: process.env.DEMO || false,
        MANAGER_ROLE_IDS: MANAGER_ROLE_IDS,
        PACKAGE_COLOR: PACKAGE_COLOR
      }
    },
    async created(){
			chatEventBus.$on('show-message-drawer', this.showMessageDrawer);
			chatEventBus.$on('show-sms-drawer', this.showSmsDrawer);
      this.getMonths()
      this.getReportPrices()
			this.getCountPendingApproval()
    },
    mounted() {
      this.initScrollbar()
		},
		beforeDestroy(){
			chatEventBus.$off('show-message-drawer', this.showMessageDrawer)
			chatEventBus.$off('show-sms-drawer', this.showSmsDrawer)
		},
		computed:{
      ...mapState(useAuthStore, ['auth_user']),
      ...mapState(useApprovalStore, ['approval_count']),
      ...mapState(useFintscoreStore, ['getReportPrices'])
    },
    methods: {
      ...mapActions(useApprovalStore, ['getCountPendingApproval']),
      ...mapActions(useDashboardStore, ['getMonths']),
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      },
			showMessageDrawer(event){
				if(!_gHlp.isEmpty(event)){
					this.$refs.messaging_drawer_store.viewMessagingDrawer(event)	
				}
			},
      showSmsDrawer(event){
				if(!_gHlp.isEmpty(event)){
					this.$refs.sms_drawer_store.viewSmsDrawer(event)	
				}
			},
			goToCommission(){
				let tkn = localStorage.getItem('auth_token')
				let app_code = localStorage.getItem('app_code')

				if(_gHlp.isEmpty(tkn) || _gHlp.isEmpty(app_code)){
					_gNotif.notifyError('Please login, Your token has expired');
					return false;
				}
				let auth_token = JSON.parse(tkn);
				let data = JSON.stringify({
					access_token: auth_token.access_token,
					expires_in: _gAuth.getActiveRemain(),
					app_code: app_code
				});
				
				let encrypt = _gHlp.aesEncrypt(data);
				let url = commissionDomain + '?auth=' + encrypt;				
				_gHlp.openNewTab(url);
			}
    }
  }
</script>
<style scoped lang="scss">
.navbar-header {
  padding: 0.675rem 1.5rem !important;
}
.g-sidenav-pinned .sidenav .navbar-header {
    display: block;
}
.sidenav .navbar-header {
    padding: 1.5rem;
    display: none;
}
</style>
